(function init() {
    var sentinels = [];

    var upcoming = document.getElementById('event-lazy-sentinel');
    if (upcoming) {
        sentinels.push(upcoming);
    }

    Array.prototype.forEach.call(document.querySelectorAll('.js-event-lazy'), function (el) {
        if (sentinels.indexOf(el) === -1) {
            sentinels.push(el);
        }
    });

    if (sentinels.length === 0) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        }
        return;
    }

    sentinels.forEach(setup);

    function setup(sentinel) {
        var pageId = parseInt(sentinel.getAttribute('data-page-id'), 10);

        if (!pageId) {
            return;
        }

        var endpoint = sentinel.getAttribute('data-endpoint') || '/webapi/eventindex/load';
        var gridId = sentinel.getAttribute('data-grid-id') || 'event-grid';
        var buttonId = sentinel.getAttribute('data-button-id') || 'event-view-more-btn';
        var spinnerId = sentinel.getAttribute('data-spinner-id') || 'event-lazy-spinner';
        var endMsgId = sentinel.getAttribute('data-end-id') || 'event-lazy-end';

        var grid = document.getElementById(gridId);
        var viewMoreBtn = document.getElementById(buttonId);
        var loadMoreWrap = sentinel.querySelector('.event-index__load-more');
        var spinner = document.getElementById(spinnerId);
        var endMsg = document.getElementById(endMsgId);

        if (!grid || !viewMoreBtn) {
            return;
        }

        var batchSize = parseInt(sentinel.getAttribute('data-page-size'), 10) || 9;
        var loaded = parseInt(sentinel.getAttribute('data-loaded'), 10) || 0;
        var total = parseInt(sentinel.getAttribute('data-total'), 10) || 0;
        var loading = false;
        var hasMore = loaded < total;

        var filters = {
            tag: sentinel.getAttribute('data-tag') || '',
            location: sentinel.getAttribute('data-location') || '',
            keyword: sentinel.getAttribute('data-keyword') || '',
            format: sentinel.getAttribute('data-format') || ''
        };

        function buildUrl() {
            var params = [
                'pageId=' + pageId,
                'skip=' + loaded,
                'take=' + batchSize
            ];

            Object.keys(filters).forEach(function (key) {
                if (filters[key]) {
                    params.push(key + '=' + encodeURIComponent(filters[key]));
                }
            });

            return endpoint + '?' + params.join('&');
        }

        function showEnd() {
            hasMore = false;

            if (loadMoreWrap) {
                loadMoreWrap.classList.add('d-none');
            }

            if (endMsg) {
                endMsg.classList.remove('d-none');
            }
        }

        function loadMore() {
            if (loading || !hasMore) {
                return;
            }

            loading = true;

            if (loadMoreWrap) {
                loadMoreWrap.classList.add('d-none');
            }

            if (spinner) {
                spinner.classList.add('show');
            }

            fetch(buildUrl())
                .then(function (r) {
                    if (!r.ok) {
                        throw new Error(r.status);
                    }
                    return r.text();
                })
                .then(function (html) {
                    if (spinner) {
                        spinner.classList.remove('show');
                    }

                    var trimmed = html.trim();

                    if (!trimmed) {
                        showEnd();
                        return;
                    }

                    var temp = document.createElement('div');
                    temp.innerHTML = trimmed;

                    var appended = 0;

                    while (temp.firstElementChild) {
                        grid.appendChild(temp.firstElementChild);
                        appended++;
                    }

                    loaded += appended;
                    sentinel.setAttribute('data-loaded', loaded);

                    loading = false;

                    if (appended < batchSize || loaded >= total) {
                        showEnd();
                    } else if (loadMoreWrap) {
                        loadMoreWrap.classList.remove('d-none');
                    }
                })
                .catch(function () {
                    if (spinner) {
                        spinner.classList.remove('show');
                    }

                    loading = false;

                    if (loadMoreWrap) {
                        loadMoreWrap.classList.remove('d-none');
                    }
                });
        }

        viewMoreBtn.addEventListener('click', loadMore);

        if (!hasMore) {
            if (loadMoreWrap) {
                loadMoreWrap.classList.add('d-none');
            }
        }
    }
}());
